import client from './client';

export default {
  all(params) {
    return client.get(`/offices${params ? '?'+params+'=true' : '' }`)
      .end();
  },

  show(params) {
    return client.get(`/offices/${params.id}`)
      .end();
  },

  create(params) {
    return client.post('/books')
      .send(params)
      .end();
  },

  fetchCaterers(params) {
    return client.get(`/offices/${params.officeId}/caterers`)
      .end();
  },

  follow(params) {
    return client.post(`/offices/${params.bookId}/follow`)
      .end();
  },

  unfollow(params) {
    return client.post(`/offices/${params.bookId}/unfollow`)
      .end();
  },

  search(params) {
    return client.get('/offices/search')
      .query(params)
      .end();
  },
};



// WEBPACK FOOTER //
// ./app/sources/api/booksAPI.js